// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VerifyPhoneNumberForm-spaceRightBtn-xdvE9 {
    margin-right: 12px;
}

.VerifyPhoneNumberForm-otpField-FQtak {
    width: 100%;
}

.VerifyPhoneNumberForm-cancelBtn-Bi4ay {
    display: inline-block;
}

.VerifyPhoneNumberForm-flexWrap-yq9ib {
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
}

.VerifyPhoneNumberForm-displayFlex-O43rq {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    display: -webkit-flex;
}

@media screen and (max-width:767px) {

    .VerifyPhoneNumberForm-otpField-FQtak {
        margin-bottom: 12px;
    }

    .VerifyPhoneNumberForm-btnSec-XiVa5 {
        -webkit-box-pack: end;
            -ms-flex-pack: end;
                justify-content: flex-end;
        width: 100%;
    }

    .VerifyPhoneNumberForm-displayFlex-O43rq {
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
    }
}

@media screen and (min-width:1200px) {
    .VerifyPhoneNumberForm-otpField-FQtak {
        width: 310px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/PhoneVerificationModal/VerifyPhoneNumberForm/VerifyPhoneNumberForm.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAe;QAAf,eAAe;AACnB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,qBAAqB;AACzB;;AAEA;;IAEI;QACI,mBAAmB;IACvB;;IAEA;QACI,qBAAyB;YAAzB,kBAAyB;gBAAzB,yBAAyB;QACzB,WAAW;IACf;;IAEA;QACI,mBAAe;YAAf,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ","sourcesContent":[".spaceRightBtn {\n    margin-right: 12px;\n}\n\n.otpField {\n    width: 100%;\n}\n\n.cancelBtn {\n    display: inline-block;\n}\n\n.flexWrap {\n    flex-wrap: wrap;\n}\n\n.displayFlex {\n    display: flex;\n    display: -webkit-flex;\n}\n\n@media screen and (max-width:767px) {\n\n    .otpField {\n        margin-bottom: 12px;\n    }\n\n    .btnSec {\n        justify-content: flex-end;\n        width: 100%;\n    }\n\n    .displayFlex {\n        flex-wrap: wrap;\n    }\n}\n\n@media screen and (min-width:1200px) {\n    .otpField {\n        width: 310px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spaceRightBtn": `VerifyPhoneNumberForm-spaceRightBtn-xdvE9`,
	"otpField": `VerifyPhoneNumberForm-otpField-FQtak`,
	"cancelBtn": `VerifyPhoneNumberForm-cancelBtn-Bi4ay`,
	"flexWrap": `VerifyPhoneNumberForm-flexWrap-yq9ib`,
	"displayFlex": `VerifyPhoneNumberForm-displayFlex-O43rq`,
	"btnSec": `VerifyPhoneNumberForm-btnSec-XiVa5`
};
module.exports = ___CSS_LOADER_EXPORT___;
